function daysLabel(mode) {
  const maxDays = Number(mode.max_days || mode.maxDays || 0);
  return mode.end_condition === 'open_ended' || mode.endCondition === 'open_ended' || mode.id === 'career' ? 'Open-ended' : maxDays ? `${maxDays} days` : 'Server managed';
}

function deadlineLabel(mode) {
  const deadline = Number(mode.debt_deadline || mode.debtDeadline || 0);
  const gated = Boolean(mode.requires_debt_clearance ?? mode.requiresDebtClearance);
  if (mode.end_condition === 'open_ended' || mode.endCondition === 'open_ended' || mode.id === 'career') return 'No fixed day limit';
  return gated && deadline ? `Debt due day ${deadline}` : 'Classic day limit';
}

export function GameModeCards({
  modes,
  selectedModeId,
  onSelect,
  disabled = false,
  compact = false,
  legend = 'Choose a game mode',
}) {
  return (
    <fieldset className={`game-mode-fieldset ${compact ? 'compact' : ''}`} disabled={disabled}>
      <legend>{legend}</legend>
      <div className="game-mode-grid" role="radiogroup" aria-label={legend}>
        {modes.map((mode) => {
          const selected = mode.id === selectedModeId;
          return (
            <button
              key={mode.id}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`game-mode-card ${selected ? 'selected' : ''}`}
              onClick={() => onSelect(mode.id)}
              disabled={disabled}
            >
              <span className="game-mode-card-topline">
                <strong>{mode.title}</strong>
                <em>{daysLabel(mode)}</em>
              </span>
              <span className="game-mode-tagline">{mode.tagline}</span>
              <small>{mode.description}</small>
              {Array.isArray(mode.highlights) && mode.highlights.length > 0 && (
                <span className="game-mode-highlights" aria-label={`${mode.title} highlights`}>
                  {mode.highlights.map((highlight) => <span key={highlight}>{highlight}</span>)}
                </span>
              )}
              <span className="game-mode-rule">{deadlineLabel(mode)}</span>
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
